import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type WorkflowStageResourceV3 = OpalApiComponent<'V3', 'workflow_stage'>

export const workflowStageResourceFactory: Factory<WorkflowStageResourceV3> =
  Factory.define<WorkflowStageResourceV3>(({ sequence }) => {
    const now = new Date().toISOString()
    return {
      id: uuidV4(),
      type: 'workflow_stage',
      attributes: {
        activated_at: null,
        created_at: now,
        updated_at: now,
        due_date: null,
        metadata: null,
        position: sequence,
        stage_type: 'task',
        status: 'inactive',
      },
      relationships: {
        assignments: { data: [] },
        workflow: { data: { id: uuidV4(), type: 'workflow' } },
      },
    } satisfies WorkflowStageResourceV3
  })
